import { MenuItem, Select, styled, TextField } from '@mui/material'

export const StyledSelect = styled(Select)(({ theme, type }) => ({
  borderRadius: '3px',
  border: 0,
  '& .MuiInputBase-input': {
    padding: type !== 'filter' ? 12 : 6
  },
  '& .MuiSelect-select': {
    fontSize: type === 'filter' ? 12 : 16
  },
  '& .MuiOutlinedInput-notchedOutline': {
    ...(type === 'filter' ? { border: 0, borderRadius: '3px' } : {})
  },
  '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
    borderWidth: '1px'
  },
  '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline ': {
    borderColor: theme.palette.primary.main,
    borderWidth: '1px'
  },
  ...(type === 'filter' ? { background: 'transparent', borderRadius: '50em' } : {})
}))

export const StyledMenuItem = styled(MenuItem)(({ theme, styledvariant, type }) => {
  let color = theme.colors.textBlack
  let hoverBackgroundColor = theme.palette.primary.main
  let hoverColor = theme.colors.black

  if (styledvariant === 'light') {
    color = theme.colors.white
    hoverBackgroundColor = 'rgba(0, 0, 0, 0.04)'
    hoverColor = theme.colors.textBlack
  }

  return ({
    '&.MuiMenuItem-root': {
      display: 'flex',
      justifyContent: 'center',
      margin: '6px',
      ml: type !== 'filter' ? 26 : 0,
      fontSize: type === 'filter' ? 12 : 16,
      marginRight: type !== 'filter' ? 26 : 3,
      marginLeft: type !== 'filter' ? 26 : 3,
      borderRadius: '22px',
      color: color,
      '&:hover': {
        background: hoverBackgroundColor,
        color: hoverColor
      }
    },
    '&.MuiMenuItem-root.Mui-selected': {
      // background: theme.palette.primary.main,
      // color: (theme) => theme.colors.white,
      // borderRadius: '22px'

    },
    '&.MuiListItemButton-root.Mui-selected': {
      backgroundColor: theme.colors.tabHover
    },
    '&.MuiListItemButton-root': {
      '&:hover': {
        backgroundColor: theme.colors.tabHover
      }
    }

  })
})

export const StyledInput = styled(TextField)(({ theme, type }) => ({
  width: '100% !important',
  padding: '0px 10px',
  '& .MuiFormControl-root': {
    width: '96%'
  },
  '& .MuiInputBase-root': {
    display: 'inline-block',
    color: theme.colors.main,
    fontSize: '12px',
    padding: '0',
    height: '30px',
    borderRadius: '30px',
    margin: '0 2px',
    backgroundColor: 'rgba(56, 148, 102, 0.08)',
    border: `1px solid ${theme.colors.shamrockGreen}`,
    'input::-webkit-input-placeholder': {
      opacity: '1'
    }
  },
  '& .MuiOutlinedInput-input': {
    padding: '5px 10px',
    height: '20px',
    width: 'calc(100% - 20px)',
    backgroundColor: theme.colors.tabHover
  },
  '& .MuiOutlinedInput-notchedOutline': {
    display: 'none'
  }
}))
